import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { InstallationNotificationWithoutEmissionPermitRoutingModule } from './installation-notification-without-emission-permit-routing.module';
import { InstallationNotificationWithoutEmissionPermitComponent } from './installation-notification-without-emission-permit.component';
import { INWEPNewRequestComponent } from './new-request/new-request.component';
import { INWEPNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [
    InstallationNotificationWithoutEmissionPermitComponent,
    INWEPNewRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    InstallationNotificationWithoutEmissionPermitRoutingModule,
    MatCheckboxModule,
  ],
  providers: [INWEPNewRequestFormService],
})
export class InstallationNotificationWithoutEmissionPermitModule {}
